export const FeedbackIcon = (props: any) => {
  return (
    <svg
      className={props.className}
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.04147 9.15393H5.63318V10.5622H7.04147V9.15393Z"
        fill="white"
      />
      <path
        d="M11.2663 9.15393H9.85803V10.5622H11.2663V9.15393Z"
        fill="white"
      />
      <path
        d="M15.4912 9.15393H14.0829V10.5622H15.4912V9.15393Z"
        fill="white"
      />
      <path
        d="M19.7161 0H1.40829C1.03492 0.000419338 0.676958 0.148927 0.412943 0.412943C0.148927 0.676958 0.000419338 1.03492 0 1.40829V14.0829C0.000419338 14.4563 0.148927 14.8143 0.412943 15.0783C0.676958 15.3423 1.03492 15.4908 1.40829 15.4912H4.22488V20.4203H5.57275L10.5018 15.4912H19.7161C20.0895 15.4908 20.4474 15.3423 20.7115 15.0783C20.9755 14.8143 21.124 14.4563 21.1244 14.0829V1.40829C21.124 1.03492 20.9755 0.676958 20.7115 0.412943C20.4474 0.148927 20.0895 0.000419338 19.7161 0ZM19.7161 14.0829H9.91848L5.63317 18.3682V14.0829H1.40829V1.40829H19.7161V14.0829Z"
        fill="white"
      />
    </svg>
  );
};
